import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import {
  AutocompleteLocation,
  IAutocompleteLocationProps,
} from './AutocompleteLocation/AutocompleteLocation'

type IBaseControllerProps = ControllerProps<React.ComponentType<IAutocompleteLocationProps>>

export interface IControlledAutocompleteLocationProps
  extends Pick<IBaseControllerProps, 'defaultValue' | 'control'> {
  /**
   * @default 'location'
   */
  name?: string
  AutocompleteLocationProps?: Partial<IAutocompleteLocationProps>
}

const ControlledAutocompleteLocation = ({
  control,
  defaultValue,
  name = 'location',
  AutocompleteLocationProps = {},
}: IControlledAutocompleteLocationProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler: IAutocompleteLocationProps['onChange'] = newVal => {
          if (newVal) {
            onChange(newVal)
          } else {
            onChange(undefined)
          }
        }

        return (
          <AutocompleteLocation
            onChange={changeHandler}
            value={value}
            {...AutocompleteLocationProps}
          />
        )
      }}
    />
  )
}

export default ControlledAutocompleteLocation
